import { Unit, BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
// import { Second, Kilogram } from "./base-units";
import { Gram, Slug, PoundLb, Grain } from "./mass";
import { Hour } from "./duration";
// MassFlow
export var KilogramPerSecond = UnitDivide.massByDuration("KilogramPerSecond", BaseUnits.Kilogram, BaseUnits.Second);
export var GramPerSecond = UnitDivide.massByDuration("GramPerSecond", Gram, BaseUnits.Second);
export var GramPerHour = UnitDivide.massByDuration("GramPerHour", Gram, Hour);
export var KilogramPerHour = UnitDivide.massByDuration("KilogramPerHour", BaseUnits.Kilogram, Hour);
export var SlugPerSecond = UnitDivide.massByDuration("SlugPerSecond", Slug, BaseUnits.Second);
export var SlugPerHour = UnitDivide.massByDuration("SlugPerHour", Slug, Hour);
export var PoundLbPerHour = UnitDivide.massByDuration("PoundLbPerHour", PoundLb, Hour);
export var PoundLbPerSecond = UnitDivide.massByDuration("PoundLbPerSecond", PoundLb, BaseUnits.Second);
export var GrainPerHour = UnitDivide.massByDuration("GrainPerHour", Grain, Hour);
export var GrainPerSecond = UnitDivide.massByDuration("GrainPerSecond", Grain, BaseUnits.Second);
export var StandardCubicMeterPerHour = Unit.timesNumber("StandardCubicMeterPerHour", 1.2041, KilogramPerHour);
export var StandardCubicFeetPerMinute = Unit.timesNumber("StandardCubicFeetPerMinute", 0.02831684660923049289319782819867, Unit.timesNumber("", 60.0, StandardCubicMeterPerHour));
export var StandardCubicMeterPerSecond = Unit.timesNumber("StandardCubicMeterPerSecond", 3600.0, StandardCubicMeterPerHour);
export var StandardLiterPerSecond = Unit.timesNumber("StandardLiterPerSecond", 3600 / 1000, StandardCubicMeterPerHour);
//# sourceMappingURL=mass-flow.js.map